import { Text } from "ui/Typography"
import PropTypes from "prop-types"
import { Flex } from "antd"
import { spacings } from "themes/variables"
import { useTranslation } from "react-i18next"
import SnapshotPriceDetails from "../SnapshotPriceDetails"

const OriginalPriceDetails = ({ originalPriceHistory }) => {
  const { payment_summary } = originalPriceHistory || {}
  const { t } = useTranslation()

  return (
    <Flex vertical gap={spacings.XS} className="px-xl py-s">
      <Text fw={500} size="lg">
        {t("client.payment.labels.price_details")}
      </Text>
      <SnapshotPriceDetails paymentSummary={payment_summary} />
    </Flex>
  )
}

OriginalPriceDetails.propTypes = {
  originalPriceHistory: PropTypes.object
}

export default OriginalPriceDetails
